import { transformServerTimePricing } from 'features/timesPrice';

import { UpdateCourtParams } from './../store/types';

interface TransformCourtInfoProps extends Omit<UpdateCourtParams, 'id'> {
  id?: number;
}

export const transformCourtInfo = ({ metainfo, surfaceType, imageId, ...req }: TransformCourtInfoProps) => ({
  ...req,
  'surface_type': surfaceType,
  'image_id': imageId,
  metainfo: metainfo && {
    pricing: transformServerTimePricing(metainfo.pricing)
  }
});


